import React, { useEffect, useMemo, useState } from 'react';
import { dataHooks } from '@wix/data-hooks';
import { Spinner, SpinnerTypes } from 'wix-ui-tpa/cssVars';
import { LocaleKeysProvider } from '../locale-keys/LocaleKeys';
import { useDeliverySectionData } from '../provider/useDeliverySectionContext';
import { DisplayState } from '../types';
import { DeliveryOptionPreview, DeliveryOptionsPicker } from '../components';
import { classes } from './DeliverySection.st.css';
import { initializeI18n } from '../utils/i18n';
export const DeliverySectionHooks = dataHooks('DeliverySection');
const ContentByDisplayState = {
  [DisplayState.HIDDEN]: null,
  [DisplayState.READ_ONLY]: DeliveryOptionPreview,
  [DisplayState.EDITABLE]: DeliveryOptionsPicker
};
export const DeliverySection = props => {
  const {
    dataHook,
    shouldShowOnlyPickup,
    displayState = DisplayState.HIDDEN,
    ...otherProps
  } = props;
  const [i18n, setI18n] = useState();
  const deliverySectionData = useDeliverySectionData();
  const Content = useMemo(() => ContentByDisplayState[deliverySectionData == null ? void 0 : deliverySectionData.displayState], [deliverySectionData == null ? void 0 : deliverySectionData.displayState]);
  useEffect(() => {
    deliverySectionData == null || deliverySectionData.setDisplayState == null || deliverySectionData.setDisplayState(displayState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!(deliverySectionData != null && deliverySectionData.setDisplayState), displayState]);
  useEffect(() => {
    deliverySectionData == null || deliverySectionData.setShouldShowOnlyPickup == null || deliverySectionData.setShouldShowOnlyPickup(shouldShowOnlyPickup);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!(deliverySectionData != null && deliverySectionData.setShouldShowOnlyPickup), shouldShowOnlyPickup]);
  useEffect(() => {
    if (deliverySectionData != null && deliverySectionData.translations && deliverySectionData != null && deliverySectionData.locale) {
      setI18n(initializeI18n(deliverySectionData == null ? void 0 : deliverySectionData.translations, deliverySectionData == null ? void 0 : deliverySectionData.locale));
    }
  }, [deliverySectionData == null ? void 0 : deliverySectionData.locale, deliverySectionData == null ? void 0 : deliverySectionData.translations]);
  if (!(i18n != null && i18n.t) || !(deliverySectionData != null && deliverySectionData.isControllerReady)) {
    if (displayState === DisplayState.HIDDEN) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": DeliverySectionHooks.loader(),
      className: classes.loader
    }, /*#__PURE__*/React.createElement(Spinner, {
      type: SpinnerTypes.slim,
      diameter: 30,
      isCentered: true
    }));
  }
  return /*#__PURE__*/React.createElement(LocaleKeysProvider, {
    translateFn: i18n == null ? void 0 : i18n.t
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook || DeliverySectionHooks.root()
  }, Content && /*#__PURE__*/React.createElement(Content, otherProps)));
};
//# sourceMappingURL=DeliverySection.js.map